export const SET_CAR_INSURANCE_POLICIES = 'SET_CAR_INSURANCE_POLICIES';
export const SET_CAR_INSURANCE_POLICIES_ERROR = 'SET_CAR_INSURANCE_POLICIES_ERROR';

export const setCarInsurancePolicies = (policies: WebExperienceApiContract.Models.CarinsurancePolicy[]) => ({
  type: SET_CAR_INSURANCE_POLICIES,
  payload: policies,
});

export const setCarInsurancePoliciesError = () => ({
  type: SET_CAR_INSURANCE_POLICIES_ERROR,
});

export interface SetCarInsurancePoliciesAction {
  type: typeof SET_CAR_INSURANCE_POLICIES;
  payload: WebExperienceApiContract.Models.CarinsurancePolicy[],
}

export interface SetCarInsurancePoliciesErrorAction {
  type: typeof SET_CAR_INSURANCE_POLICIES_ERROR;
}

export type ProductAction =
  | SetCarInsurancePoliciesAction
  | SetCarInsurancePoliciesErrorAction;
